// extracted by mini-css-extract-plugin
module.exports = {"uploadHandler":"ImageUploadHandler_uploadHandler__27Gip","uploadHandlerBtn":"ImageUploadHandler_uploadHandlerBtn__3U6Jr"};